import { ref } from 'vue';

export function useRefHooks(initValue) {
  const data = ref(initValue);
  function setData(newValue) {
    data.value = newValue;
  }
  return [data, setData];
}

export function useReactiveHooks(initValue) {
  return [];
}
